import dayjs from 'dayjs';
import Cookies from 'js-cookie';

import { GlintsTrackingClient } from './GlintsTrackingClient';

export function getTrackingPageUrl() {
  const url = new URL(window.location.href);
  if (url.pathname.replace(/\/$/, '') === '/forgot-password') {
    url.searchParams.delete('token');
    url.searchParams.delete('id');
    url.searchParams.delete('email');
    url.hash = '';
  }
  return url;
}

const glintsTrackingCookieName = 'glints_tracking_id';
const glintsTrackingPageViewTimeKey = 'glints_tracking_page_view_time';

export function getGlintsTrackingPageName(document: Document) {
  return document
    .querySelector('meta[property="glints:tracking_name"]')
    ?.getAttribute('content');
}

export function getGlintsTrackingIDFromCookie() {
  return Cookies.get(glintsTrackingCookieName);
}

export function setGlintsTrackingIDToCookie(trackingID: string) {
  const in30Minutes = new Date(new Date().getTime() + 30 * 60 * 1000);
  Cookies.set(glintsTrackingCookieName, trackingID, {
    expires: in30Minutes,
  });
}

export function setPageViewTime(pageName: string) {
  const currentTime = dayjs().valueOf();
  sessionStorage.setItem(
    `${glintsTrackingPageViewTimeKey}_${pageName}`,
    currentTime.toString()
  );
  return currentTime;
}

export function getPageViewTime(
  pageName: string,
  _sessionStorage?: Storage
): number | null {
  const pageViewTime = (_sessionStorage ?? sessionStorage).getItem(
    `${glintsTrackingPageViewTimeKey}_${pageName}`
  );
  if (!pageViewTime) return null;
  return dayjs(parseInt(pageViewTime)).valueOf();
}

export function initializePreviousPageInfoFromReferrer() {
  try {
    if (
      window.opener?.document?.querySelector &&
      window.opener?.sessionStorage
    ) {
      const pageNameFromReferer = getGlintsTrackingPageName(
        window.opener.document as Document
      );
      if (pageNameFromReferer) {
        GlintsTrackingClient.getInstance().setPreviousPageInfo({
          pageName: pageNameFromReferer,
          pageViewTime: getPageViewTime(
            pageNameFromReferer,
            window.opener.sessionStorage
          ) as number,
          pagePath: window.opener.location.pathname,
        });
      }
    }
  } catch (error) {
    console.error(error);
  }
}
